import countAnimationGroup from './countAnimationGroup'
const menuScroll = {}
menuScroll.item = document.querySelectorAll(".sc_item")
menuScroll.sections = document.querySelectorAll('.section')
menuScroll.init = function(obj){
	const body = document.body
	const menu = document.querySelector('#menu')
	const menuM = document.querySelector('#menu_m')
	const header = document.querySelector('#header')
	
	let timer = null
	let time = 700
	const mobileWidth = 1200
	Array.prototype.forEach.call(menuScroll.item, (mainItem, index) => {
		let idx = index
		const dataIndex = mainItem.getAttribute('data-index')
		if(!!dataIndex){
			idx = parseInt(dataIndex)
		}
		mainItem.addEventListener('click',function(){
			clearTimeout(timer)

			if(!!menuScroll.countGroup){
				countAnimationGroup.reset(menuScroll.countGroup)
			}

			Array.prototype.forEach.call(menuScroll.item, item=>{
				if(item != this){
					item.classList.remove('active')
				}else{
					if(!dataIndex){
						item.classList.add('active')
					}
				}
			})
			
			if(!!dataIndex){
				menuScroll.item[idx+1].classList.add('active')
			}
			if(!!menuScroll.scTar){
				menuScroll.scTar.classList.remove('active')
			}
			menuM.classList.remove('active')
			body.classList.remove('lock')
			menu.classList.remove('active')
			
			const dataId = this.getAttribute('data-id')
			menuScroll.scTar = document.querySelector(`#${dataId}`)

			/*
			const noScroll = mainItem.getAttribute('data-noScroll')
			if(noScroll == 'noScroll'){
				window.noScroll = true
				menuScroll.scTar.classList.add('active')
				const viewItems = menuScroll.scTar.querySelectorAll('.view_item')
				setTimeout(function(){
					Array.prototype.forEach.call(viewItems, item => {
						item.classList.add('trans')
					})
				}, 500)
				return
			}else{
				window.noScroll = false
				const pointsNextHide = document.querySelector('.points_next_hide')
				if(!!pointsNextHide) {
					pointsNextHide.classList.remove('points_next_hide')
				}
			}
			//*/
			
			menuScroll.scTar.scrollIntoView({ behavior: "smooth", block: "start" })

			menuScroll.countGroup = menuScroll.scTar.querySelectorAll('.count_group')
			if(!!menuScroll.countGroup){
				countAnimationGroup.count(menuScroll.countGroup)
			}
			
			// setTimeout(function(){
			// 	var y = window.scrollY
			// 		if(y){
			// 		window.scroll({ top: y - header.clientHeight, behavior: "smooth" })
			// 	}
			// }, 800)
			// console.log(menuScroll.scTar)
			
			const ww = window.innerWidth
			if(ww>mobileWidth){
				scrollHorizontal.isReset = true
			}
			setTimeout(()=>{
				window.location.hash = this.getAttribute('data-id')
			}, 1000)
			// setPeopleBoxWidth.setWidth(idx)
			if(ww>mobileWidth){
				timer = setTimeout(()=>{
					scrollHorizontal.resetPos(this.getAttribute('data-id'))
				}, time)
			}
		})
	})
}
export default menuScroll;
